import gluteosUrl from '/public/images/trainings/gluteos.webp'
import curtoIntensoUrl from '/public/images/trainings/curto-intenso.webp'
import cardioUrl from '/public/images/trainings/cardio.webp'
import reduzirMedidasUrl from '/public/images/trainings/reduzir-medidas.webp'
import hipertrofiaUrl from '/public/images/trainings/hipertrofia.webp'
import yogaUrl from '/public/images/trainings/yoga.webp'

export const TRAININGS = [
  {
    imageName: 'gluteos.webp',
    imageUrl: gluteosUrl,
    alt: 'Treinos para definir os gluteos'
  },
  {
    imageName: 'curto-intenso.webp',
    imageUrl: curtoIntensoUrl,
    alt: 'Treinos curtos e intensos'
  },
  {
    imageName: 'cardio.webp',
    imageUrl: cardioUrl,
    alt: 'Treinos para queimar gordura'
  },
  {
    imageName: 'reduzir-medidas.webp',
    imageUrl: reduzirMedidasUrl,
    alt: 'Aulas para reduzir medidas'
  },
  {
    imageName: 'hipertrofia.webp',
    imageUrl: hipertrofiaUrl,
    alt: 'Treinos para hipertrofia'
  },
  {
    imageName: 'yoga.webp',
    imageUrl: yogaUrl,
    alt: 'Aulas de Yoga'
  }
]
